import { Row } from 'antd';
import { useAppSelector } from 'app/hooks';
import clsx from 'clsx';
import { selectUserInfo } from 'components/Layout/homeSlice';
import * as React from 'react';
import { FaDollyFlatbed, FaIndustry, FaStreetView, FaUserCircle } from 'react-icons/fa';
import style from './MenuUser.module.scss';
export interface MenuUserProps {
  setIsShowItem: (value: string) => void;
  isShowItem: string;
}

export default function MenuUser({ setIsShowItem, isShowItem }: MenuUserProps) {
  const userInfo = useAppSelector(selectUserInfo);
  const data = [
    {
      content: 'Plant',
      icon: <FaIndustry />,
    },
    {
      content: 'Gateways',
      icon: <FaDollyFlatbed />,
    },
    {
      content: 'Viewer',
      icon: <FaStreetView />,
    },
  ];
  return (
    <div className={style.root}>
      <div className={style.name_plant}>
        <FaUserCircle size={40} />
        <p>
          {userInfo?.last_name} {userInfo?.first_name}
        </p>
      </div>
      <div className={style.sidebar_main_management}>
        {data.map((item, index) => (
          <Row
            align={'middle'}
            key={`menuUser_${index}`}
            onClick={() => {
              setIsShowItem(item.content);
            }}
            className={clsx (style.item_sidebar_management, {
              [style.active]: isShowItem === item.content,
            })}
          >
            <div
              style={{
                fontSize: '20px',
                marginRight: '20px',
              }}
            >
              {item.icon}
            </div>
            {item.content}
          </Row>
        ))}
      </div>
    </div>
  );
}
